import React from "react";
import { Cards, TitlePage } from "../../components";
import { content } from "../../Context/translate";
import { fileUrl, useFETCH } from "../../Tools/APIs";
import { Col, Row } from "../../Tools/Grid-system";
import Loading from "../../Tools/Loading";
import { FaCheckCircle } from "react-icons/fa";

export const FEATURES = [
  {
    key: "CHAT",
    name: "الدردشة",
  },
  {
    key: "PROFILE_VISITORS",
    name: "رؤية من زار بروفايلي",
  },
  {
    key: "CARES",
    name: "القدرة على اهتمام بشخص ما",
  },
  {
    key: "CHAT_NATIONALITIES",
    name: "القدرة على تحديد الجنسيات التي تراسلني",
  },
  {
    key: "CHAT_COUUNTRIES",
    name: "القدرة على تحديد البلدان التي تراسلني",
  },
  {
    key: "PREMIUM_SHOW",
    name: "الظهور في القائمة المميزة",
  },
  // {
  //   key: "MANAGE_NOTIFICATIONS",
  //   name: "التحكم بالاشعارات التي تصلني",
  // },
];

const PREMIUM_DESCRIPTION =
  "باقة التميز هي مجموعة من الخدمات والخصائص المميزة، تزيد من فعاليتك في الموقع وتساعدك على إظهار ملفك بشكل أفضل وتزيد زيارات الأعضاء لملفك الشخصي وتحقيق هدفك بشكل أسرع";

const FeaturesCards = () => (
  <div
    className="flex flex-wrap gap-4 py-4 px-1 justify-center rounded-xl border border-sm shadow-md"
  >
    {FEATURES.map((feature, idx) => (
      <div
        key={feature.key}
        className="w-[220px] bg-white rounded-xl shadow-md flex flex-col items-center justify-center p-6 border border-pink-100"
      >
        <span className="mb-3 text-pink-500">
          <FaCheckCircle size={32} />
        </span>
        <p className="text-center font-semibold text-gray-800">{feature.name}</p>
      </div>
    ))}
  </div>
);

const Packages = () => {
  const { data, isLoading } = useFETCH("v1/packages");

  if (isLoading) return <Loading />;

  // ابحث فقط عن الباقة السنوية
  const annualPackage = data?.data?.data?.find(
    (pkg) => pkg.duration >= 360 // اعتبر 360 يوم أو أكثر سنوي
  );

  return (
    <Col md={11} className="mx-auto space-y-6">
      <TitlePage title={content.buyPackages} />
      {/* شرح باقة التميز */}
      <div className="bg-white rounded-xl shadow p-6 text-center max-w-2xl mx-auto">
        <h2 className="text-2xl font-bold text-pink-600 mb-2">باقة التميز</h2>
        <p className="text-gray-700 text-lg">{PREMIUM_DESCRIPTION}</p>
      </div>
      {/* الميزات */}
      <FeaturesCards />
      {/* الباقة السنوية */}
      <div className="flex justify-center mt-8">
        {annualPackage ? (
          <div className="bg-white rounded-xl shadow-lg p-8 flex flex-col items-center min-w-[320px] border border-pink-200">
            <h3 className="text-xl font-bold text-pink-600 mb-2">{annualPackage.name}</h3>
            <div className="flex items-center gap-2 mb-4">
              <span className="text-gray-700 text-lg">مدة الاشتراك:</span>
              <span className="text-blue-900 font-semibold">{annualPackage.duration} يوم</span>
            </div>
            
            <div className="flex items-center gap-2 mb-4">
            <span className="text-gray-700 text-lg">عدد الرسائل:</span>
              <span className="text-gray-500 line-through text-lg">{annualPackage.messages_count}</span>
            </div>

            <div className="flex items-center gap-2 mb-4">
              <span className="text-gray-700 text-lg">السعر:</span>
              <span className="text-green-700 text-2xl font-bold">${annualPackage.new_price}</span>
              {annualPackage.old_price && (
                <span className="text-gray-500 line-through text-lg">${annualPackage.old_price}</span>
              )}
            </div>
            <button
              onClick={() => {
                // نفس زر الاشتراك القديم
                const features = annualPackage.features
                  .split(",")
                  .map((featureKey) => {
                    const feature = FEATURES.find((f) => f.key === featureKey.trim());
                    return feature ? feature.name : featureKey.trim();
                  })
                  .join("\n• ");
                const message = `\n🌟 مرحبًا! أرغب في الاشتراك في الباقة التالية 🌟\n\n📦 *الباقة*: ${annualPackage.name} (ID: ${annualPackage.id})\n\n🗓️ *المدة*: ${annualPackage.duration} يوم\n\n💰 *السعر*:\n   - *السعر الجديد*: ${annualPackage.new_price}$\n   ${annualPackage.old_price ? `- *السعر القديم*: ~${annualPackage.old_price}$~` : ""}\n\n${annualPackage.messages_count ? `💬 *الرسائل*: ${annualPackage.messages_count} رسالة` : ""}\n\n✨ *المميزات*:\n• ${features}\n\nشكراً لكم!\n`;
                const encodedMessage = encodeURIComponent(message);
                const whatsappUrl = `https://wa.me/963930710649?text=${encodedMessage}`;
                window.open(whatsappUrl, "_blank");
              }}
              className="mt-4 w-full rounded-lg bg-pink-500 py-3.5 px-7 text-center font-bold uppercase text-white shadow-md hover:shadow-lg transition-all"
              type="button"
            >
              {content.Subscribe}
            </button>
          </div>
        ) : (
          <Cards>
            <div className="flex justify-center items-center p-8">
              <h1 className="text-gray-700 text-2xl font-bold">لا يوجد باقة سنوية متاحة</h1>
            </div>
          </Cards>
        )}
      </div>
    </Col>
  );
};

export default Packages;
